<template>
	<input value="0" v-on:input="dmodel=$event.target.value" />
</template>
<script>
export default {
  name: 'dinput',
  props: {
    dmodel: {
      type: String,
      default: 'sales'
    },
  }
}
</script>